import React from 'react';
import AboutUs from '../component/aboutUs/AboutUs';
import { Helmet } from 'react-helmet';
import ComponenetHeader from '../component/common/ComponenetHeader';

const AboutPage = () => {

  return (
    <>
      <Helmet>
        <link rel="canonical" href="/about"/>
        <title>Reliable Truck Road Services – Fast Response, Low Cost</title>
        <meta name="keywords" content="truck road services , tow truck services,truck trailer repair,heavy duty truck repair,commercial truck repair,truck maintenance"/>
        <meta name="description" content="When every minute counts, trust our truck road services for fast, reliable help anywhere in the U.S. Affordable, stress-free, and always on time." />
        <meta property="og:title" content="Reliable Truck Road Services – Fast Response, Low Cost" />
        <meta property="og:description" content="When every minute counts, trust our truck road services for fast, reliable help anywhere in the U.S. Affordable, stress-free, and always on time." />
      </Helmet>
      <ComponenetHeader
        name={'About Us'}
      />
      <AboutUs />
    </>
  );
};

export default AboutPage;